// extracted by mini-css-extract-plugin
export var bold = "_xx-0";